// Intentionally global
___export = require('./../../lib/src-server/azure-timer').run(require('./../../lib/src-server/example-timer-keep-alive').tick);
module.exports = ___export;


//////////////////
// WEBPACK FOOTER
// ./deployment/example-timer-keep-alive/build.source.js
// module id = 286
// module chunks = 15